export default "__VITE_ASSET__oW6Awy_k__"